import { Badge } from "../ui/badge";

const COMPLEXITY_STYLES = {
  simple: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30",
  standard: "bg-blue-500/10 text-blue-600 border-blue-500/30",
  complex: "bg-rose-500/10 text-rose-600 border-rose-500/30",
};

export const STATUS_LABELS = {
  ready: "On Shelf",
  claimed: "Claimed",
  in_prep: "In Progress",
  complete: "Finished",
};

const STATUS_STYLES = {
  ready: "bg-sky-500/10 text-sky-600 border-sky-500/30",
  claimed: "bg-indigo-500/10 text-indigo-600 border-indigo-500/30",
  in_prep: "bg-amber-500/10 text-amber-600 border-amber-500/30",
  complete: "bg-emerald-500/10 text-emerald-600 border-emerald-500/30",
};

export const ComplexityChip = ({ value }) => (
  <Badge variant="outline" className={`text-[10px] uppercase tracking-wider font-semibold ${COMPLEXITY_STYLES[value] || COMPLEXITY_STYLES.standard}`}>
    {value}
  </Badge>
);

export const StatusChip = ({ value }) => (
  <Badge variant="outline" className={`text-[10px] uppercase tracking-wider font-semibold ${STATUS_STYLES[value] || STATUS_STYLES.ready}`}>
    {STATUS_LABELS[value] || value}
  </Badge>
);

export const TouchAge = ({ hours }) => {
  const tone =
    hours >= 72 ? "text-rose-600" : hours >= 48 ? "text-amber-600" : "text-muted-foreground";
  const label = hours < 24 ? `${Math.round(hours)}h untouched` : `${Math.floor(hours / 24)}d untouched`;
  return <span className={`text-xs font-medium tabular-nums ${tone}`}>{label}</span>;
};
